module.exports = __webpack_public_path__ + "static/media/shuzhihua2.d860d273.png";